<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="mx-auto">
      <v-data-table
        :headers="headers"
        :items="issues"
        :page="page"
        :pageCount="numberOfPages"
        :items-per-page="itemsPerPage"
        class="elevation-2 striped"
        v-model="selectedRows"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          'items-per-page-text': `${perPageText}`,
        }"
        :loading="loadTable"
        :loading-text="$t('common.loadingText')"
      >
        <template v-slot:[`body.prepend`]>
          <tr>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="id"
                type="text"
                :label="$t('_issues.id')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="categoryName"
                type="text"
                :label="$t('_issues.category')"
              ></v-text-field>
            </td>
            <!-- <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="issueSubject"
                type="text"
                :label="$t('_issues.issueSubject')"
              ></v-text-field>
            </td> -->
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="issueDescription"
                type="text"
                :label="$t('_issues.issueDescription')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="creatorName"
                type="text"
                :label="$t('_issues.creatorName')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="creatorPhone"
                type="text"
                :label="$t('_issues.creatorPhone')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="creatorEmail"
                type="text"
                :label="$t('_issues.creatorEmail')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell"></td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="operatorId"
                type="text"
                :label="$t('_issues.operatorId')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="operatorReply"
                type="text"
                :label="$t('_issues.operatorReply')"
              ></v-text-field>
            </td>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr
            :style="
              selectedRows.indexOf(item.id) > -1
                ? 'background-color:#82DAC0'
                : ''
            "
            @click="rowClick(item)"
          >
            <td>{{ item.id.split("-")[0] }}</td>
            <!-- <td>{{ item.issueNumber }}</td> -->
            <td>{{ item.categoryName }}</td>
            <!-- <td>{{ item.issueSubject }}</td> -->
            <td>{{ item.issueDescription }}</td>
            <td>{{ item.creatorName }}</td>
            <td>{{ item.creatorPhone }}</td>
            <td>{{ item.creatorEmail }}</td>
            <td>{{ item.creationDateTime }}</td>
            <td>{{ item.operatorId }}</td>
            <td>{{ item.operatorReply }}</td>
            <td>{{ item.doneDateTime }}</td>
            <td>
              <v-enum-span :value="item.status" :enum="$enums.issueStatus" />
            </td>

            
            <td align="right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon small @click="itemPhoto(item)" color="blue">
                      photo_camera
                    </v-icon></v-btn
                  >
                </template>
                <span>{{ $t("actions.showPhoto") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon small @click="reply(item)" color="orange">
                      reply
                    </v-icon></v-btn
                  >
                </template>
                <span>{{ $t("actions.reply") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-card-text>{{ $t("common.dataNotFound") }}</v-card-text>
        </template>
      </v-data-table>
      <v-dialog
        width="1000"
        :retain-focus="false"
        v-model="showPhoto"
        v-if="selectedItem != null && selectedItem.issueAssets.length != 0"
      >
        <v-card max-width="1000" dark>
          <v-card-title>{{ selectedItem.categoryName }} </v-card-title>
          <v-carousel show-arrows-on-hover v-model="currentIndex" height="500">
            <v-carousel-item
              v-for="(asset, i) in selectedItem.issueAssets"
              :key="i"
            >
              <v-img :src="asset.photoUrl" contain max-height="450"/>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        elevation="24"
        :color="snackColor"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Kapat
          </v-btn>
        </template>
      </v-snackbar>
      <reply-issue-button
        :dialog.sync="dialog"
        :editedItem="editedItem"
        :editedIndex="itemIndex"
        :issueCategories="issueCategories"
        @confirmed="onConfirmed"
        @cancelled="onCancelled"
      />
      <!-- <new-news-button
        :dialog.sync="dialog"
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        :counties="counties"
        :neighborhoods="neighborhoods"
        :incidentTypes="incidentTypes"
        @confirmed="onConfirmed"
        @cancelled="onCancelled"
      /> -->
    </v-card>
  </div>
</template>

<script>
import ReplyIssueButton from "./ReplyIssueButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { ReplyIssueButton },
  props: {
    filter: Object,
    issueItems: Array,
    issueCategories: Array,
  },
  data() {
    return {
      editedIndex: -1,
      editedItem: {
        id: "",
        status: "",
        categoryName: "",
        issueSubject: "",
        issueDescription: "",
        operatorReply: "",
        issueAssets: [],
      },
      id: "",
      categoryName: "",
      issueDescription: "",
      creatorName: "",
      creatorPhone: "",
      creatorEmail: "",
      operatorId: "",
      operatorReply: "",
      status: "",
      assets: [],
      categories: [],
      totalCount: 0,
      page: 0,
      numberOfPages: 5,
      itemsPerPage: 5,
      totalItemsPerPage: 10000,
      sortField: "creationDateTime",
      sortOrder: -1,
      options: {},
      selectedRows: [],
      showPhoto: false,
      selectedItem: null,
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: "",
      y: "",
      timeout: 3000,
      currentIndex: -1,
      loadTable: true,
      overlay: true,
    };
  },
  async created() {
    console.log("news are refreshing due to creating");
    await this.refreshTable();
  },
  computed: {
    ...mapGetters({ items: "issues/items" }),
    ...mapGetters({ language: "app/language" }),
    headers() {
      return [
        {
          text: this.$t("_issues.id"),
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("_issues.category"),
          sortable: true,
          value: "categoryName",
        },
        // {
        //   text: this.$t("_issues.issueSubject"),
        //   sortable: true,
        //   value: "issueSubject",
        // },
        {
          text: this.$t("_issues.issueDescription"),
          sortable: false,
          value: "issueDescription",
        },
        {
          text: this.$t("_issues.creatorName"),
          sortable: true,
          value: "creatorName",
        },
        {
          text: this.$t("_issues.creatorPhone"),
          sortable: false,
          value: "creatorPhone",
        },
        {
          text: this.$t("_issues.creatorEmail"),
          sortable: false,
          value: "creatorEmail",
        },
        {
          text: this.$t("_issues.creationDateTime"),
          sortable: true,
          value: "creationDateTime",
        },

        {
          text: this.$t("_issues.operatorId"),
          sortable: true,
          value: "operatorId",
        },
        {
          text: this.$t("_issues.operatorReply"),
          sortable: false,
          value: "operatorReply",
        },

        {
          text: this.$t("_issues.doneDateTime"),
          sortable: true,
          value: "doneDateTime",
        },

        {
          text: this.$t("_issues.status"),
          sortable: true,
          value: "status",
          divider: true,
        },
        {
          text: this.$t("_issues.actions"),
          sortable: false,
          value: "actions",
          align: "right",
          width: "140px",
        },
        // {
        //   text: this.$t("_issues.actions"),
        //   value: "actions",
        //   sortable: false,
        //   align: "right",
        //   divider: false,
        //   width: 130,
        // },
      ];
    },
    perPageText() {
      if (this.language == "en_US") {
        return "Rows per page:";
      }
      return "Sayfa başına satır:";
    },
    issues() {
      let conditions = [];
      if (this.id) {
        conditions.push(this.filterId);
      }
      if (this.categoryName) {
        conditions.push(this.filterCategoryName);
      }
      if (this.issueDescription) {
        conditions.push(this.filterIssueDescription);
      }
      if (this.creatorName) {
        conditions.push(this.filterCreatorName);
      }
      if (this.creatorPhone) {
        conditions.push(this.filterCreatorPhone);
      }
      if (this.creatorEmail) {
        conditions.push(this.filterCreatorEmail);
      }
      if (this.operatorId) {
        conditions.push(this.filterOperatorId);
      }
      if (this.operatorReply) {
        conditions.push(this.filterOperatorReply);
      }
      if (conditions.length > 0) {
        return this.issueItems.filter((item) => {
          return conditions.every((condition) => {
            return condition(item);
          });
        });
      }
      return this.issueItems;
    },
  },
  methods: {
    ...mapActions(["issues/getItems"]),
    ...mapActions({
      removeNews: "news/remove",
      uploadAsset: "news/uploadPlaceAsset",
    }),
    filterId(item) {
      console.log(item.id);
      return item.id.toLowerCase().includes(this.id.toLowerCase());
    },
    filterCategoryName(item) {
      console.log(item.categoryName);
      return item.categoryName
        .toLowerCase()
        .includes(this.categoryName.toLowerCase());
    },
    filterIssueDescription(item) {
      return item.issueDescription
        .toLowerCase()
        .includes(this.issueDescription.toLowerCase());
    },
    filterCreatorName(item) {
      return item.creatorName
        .toLowerCase()
        .includes(this.creatorName.toLowerCase());
    },
    filterCreatorPhone(item) {
      return item.creatorPhone
        .toLowerCase()
        .includes(this.creatorPhone.toLowerCase());
    },
    filterCreatorEmail(item) {
      return item.creatorEmail
        .toLowerCase()
        .includes(this.creatorEmail.toLowerCase());
    },
    filterOperatorId(item) {
      return item.operatorId
        .toLowerCase()
        .includes(this.operatorId.toLowerCase());
    },
    filterOperatorReply(item) {
      return item.operatorReply
        ? item.operatorReply
            .toLowerCase()
            .includes(this.operatorReply.toLowerCase())
        : "";
    },
    async refreshTable() {
      let filterr = JSON.parse(JSON.stringify(this.filter));
      //filterr.categoryIds.push(this.groupId);
      await this.$store.dispatch("issues/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        filter: filterr,
      });
      this.overlay = false;

      this.loadTable = false;
    },
    async reply(item) {
      this.editedItem.id = item.id;
      this.editedItem.status = item.status;
      this.editedItem.categoryName = item.categoryName;
      this.editedItem.issueSubject = item.issueSubject;
      this.editedItem.issueDescription = item.issueDescription;
      this.editedItem.operatorReply = item.operatorReply;
      this.dialog = true;
    },
    fileUploaded() {
      // hide a dialog
      this.refreshTable();
      // save a user and refresh a table
    },
    async deleteItem(item) {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Haberi silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#ff7674",
          cancelButtonColor: "#41b882",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeNews({
                item: item,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Olay silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Olay silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    itemPhoto(item) {
      this.selectedItem = { ...item };
      if (this.selectedItem.issueAssets.length == 0) {
        this.snackbar = true;
        this.snackColor = "warning";
        this.snackText = "Fotoğraf bulunamadı!";
        this.y = "bottom";
        this.x = "right";
        this.mode = "multi-line";
      }
      this.showPhoto = true;
    },
    async deletePhoto() {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Fotoğrafı silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          cancelButtonColor: "#41b882",
          confirmButtonColor: "#ff7674",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeAsset({
                placeId: self.selectedItem.id,
                assetId: self.selectedItem.placeAssets[self.currentIndex].id,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Kayıt silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
              self.showPhoto = false;

              self.$emit("fileUploaded");
              self.selectedItem.placeAssets.splice(self.currentIndex, 1);
              self.showPhoto = true;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Kayıt silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    async editItem(item) {
      console.log(item);
      this.editedIndex = this.news.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.startDate = new Date(
        item.startTime.getTime() - item.startTime.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10);

      this.editedItem.endDate = new Date(
        item.endTime.getTime() - item.endTime.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10);

      this.editedItem.startTime = new Date(
        item.startTime.getTime() - item.startTime.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(11, 16);

      this.editedItem.endTime = new Date(
        item.endTime.getTime() - item.endTime.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(11, 16);

      console.log(item.incidentType.name);
      this.editedItem.name = item.incidentType.name;
      this.dialog = true;
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      this.refreshTable();
      //this.$emit("fileUploaded");
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    rowClick(item, row) {
      console.log("row clicked");
      console.log(item.id);
      // row.select(true);
      this.selectedId = item.name;
      this.toggleSelection(item);
      console.log("rowclickkkk");
    },
    toggleSelection(item) {
      if (this.selectedRows.includes(item.id)) {
        console.log(this.selectedRows);
        this.selectedRows = this.selectedRows.filter(
          (selectedKeyID) => selectedKeyID !== item.id
        );
        this.$emit("placeReClick");
      } else if (this.selectedRows.length == 0) {
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      } else if (
        !this.selectedRows.includes(item.id) &&
        this.selectedRows.length == 1
      ) {
        this.selectedRows.pop();
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      }
    },
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    language: function () {
      console.log("lang changed");
      this.refreshTable();
    },
    filter: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
};
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>
